import React, { useState, useRef, useEffect } from "react";
import {
  MapContainer,
  TileLayer,
  Marker,
  useMap,
  useMapEvents,
} from "react-leaflet";
import L from "leaflet";
import axios from "axios";
import "leaflet/dist/leaflet.css";
import styles from "./AddressForm.module.css";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

// Fix for default marker icon issue
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

// Custom arrow icon
const arrowIcon = new L.Icon({
  iconUrl: require("./pin.png"),
  iconSize: [24, 24],
  iconAnchor: [12, 24],
});

// default center of the map
const center = [33.6966781, 73.0508972];

function SetViewOnClick({ coords, shouldPan }) {
  const map = useMap();
  React.useEffect(() => {
    if (shouldPan && coords[0] !== 0 && coords[1] !== 0) {
      map.setView(coords, 13);
    }
  }, [coords, map, shouldPan]);
  return null;
}

const AddressForm = () => {
  const [mapCenter, setMapCenter] = useState(center);
  const [marker, setMarker] = useState(null);
  const [error, setError] = useState("");
  const [shouldPan, setShouldPan] = useState(false);
  const [nearbyArenas, setNearbyArenas] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const mapRef = useRef(null);
  const navigate = useNavigate();
  const { user } = useAuth();

  const MapEvents = () => {
    useMapEvents({
      dragstart: () => setShouldPan(false),
      zoomstart: () => setShouldPan(false),
    });
    return null;
  };

  useEffect(() => {
    showArenas();
  }, []); // Empty dependency array means this effect runs once on mount

  const showArenas = async () => {
    setIsLoading(true);
    setError("");
    try {
      const userId = user?.uid;
      if (!userId) {
        throw new Error("User ID not found. Please log in.");
      }
      console.log(userId);

      const response = await axios.get(
        `${
          process.env.REACT_APP_BASE_URL
        }/api/arena-dashboard/nearby-Arenas?userId=${encodeURIComponent(
          userId
        )}`,
        { withCredentials: true }
      );

      const arenas = response.data;
      if (arenas.length === 0) {
        setError("No nearby arenas found");
      } else {
        setNearbyArenas(arenas);

        if (mapRef.current && arenas.length > 0) {
          const bounds = new L.LatLngBounds();
          arenas.forEach((arena) => {
            const [lat, lng] = arena.coordinates
              .split(",")
              .map((coord) => parseFloat(coord.trim()));
            bounds.extend(new L.LatLng(lat, lng));
          });
          mapRef.current.fitBounds(bounds);
        }
      }
    } catch (err) {
      console.error("Error fetching nearby arenas:", err);
      setError(
        err.message || "Error fetching nearby arenas. Please try again."
      );
    } finally {
      setIsLoading(false);
    }
  };

  const handleMarkerClick = (arenaId) => {
    navigate(`/arena-details/${arenaId}`);
  };

  return (
    <div className={styles.formContainer}>
      <div className={styles.formContent}>
        <div className={styles.mapContainer}>
          <MapContainer
            center={mapCenter}
            zoom={13}
            style={{ height: "100%", width: "100%" }}
            ref={mapRef}
            zoomControl={false}
          >
            <TileLayer
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              attribution="© OpenStreetMap"
            />
            {marker && <Marker position={marker} />}
            {nearbyArenas.map((arena, index) => (
              <Marker
                key={index}
                position={arena.coordinates
                  .split(",")
                  .map((coord) => parseFloat(coord.trim()))}
                icon={arrowIcon}
                title={arena.Arena_name}
                eventHandlers={{
                  click: () => handleMarkerClick(arena.arena_id),
                }}
              />
            ))}
            <SetViewOnClick coords={mapCenter} shouldPan={shouldPan} />
            <MapEvents />
          </MapContainer>
        </div>
      </div>
      {/* {error && <div className={styles.errorMessage}>{error}</div>} */}
      {isLoading && (
        <div className={styles.loadingMessage}>Loading nearby arenas...</div>
      )}
    </div>
  );
};

export default AddressForm;
